import React from 'react';
import {Alert, FlatList, TouchableOpacity, View} from 'react-native';
import Icon from 'react-native-vector-icons/MaterialCommunityIcons';
import {useSelector} from 'react-redux';
import {apiFlagPhotos} from 'src/Utils/apiCalls';
import FastImage from 'src/Utils/FastImage';

import useWindowDimensionsSafe from 'src/Modules/Native/useWindowDimensionsSafe';

/////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
////////////  NOT USING FASTIMAGE DUE TO CRASHING MEMORY ISSUES ON IOS
/////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
import {navigationRef} from 'src/Nav/navigationHelpers';
import {BodyText} from 'src/Modules/CommonView';
import Video from 'src/Modules/Native/Video';
import CustomActivityIndicator from '../Modules/CommonView/CustomActivityIndicator';
import {cloudFlareOptimizeImage} from '../Utils/helpers';

const markerIcon = require('src/Images/Icons/mapMarker2.png');

const CommunityPhotos = ({fetchSetTopPhotos}) => {
  const communityPhotos = useSelector((state) => state.communityPhotos?.photos);
  return (
    <View style={{flex: 1, paddingTop: 5}}>
      {!!communityPhotos?.length ? (
        <FlatList
          data={communityPhotos}
          removeClippedSubviews
          keyExtractor={(item) => item.UUID}
          contentContainerStyle={{paddingBottom: 60}}
          renderItem={({item, index}) => {
            // global.devAlert(item);
            return (
              <PhotoTile
                handlePress={() => {
                  navigationRef.navigate('CommunityViewPhoto', {photo: item});
                }}
                photo={item}
                index={index}
                fetchSetTopPhotos={fetchSetTopPhotos}
              />
            );
          }}
        />
      ) : (
        <View>
          <BodyText text={'Loading...'} />
          <CustomActivityIndicator
            size={'large'}
            color={global?.color?.gray3}
          />
        </View>
      )}
    </View>
  );
};

export const PhotoTile = ({
  photo,
  handlePress,
  index,

  fetchSetTopPhotos,
  descriptionOverride,
  descriptionStyle = {},
}) => {
  if (!photo) {
    return <View></View>;
  }

  const {width} = useWindowDimensionsSafe();
  const photoUrl =
    photo.thumbnail ||
    photo.share_photo ||
    photo.photoURL ||
    photo.photoUrl ||
    photo.downloadURL ||
    (photo.completion ? photo.completion.photoUrl : null);

  const challengeText =
    photo.challengeText ||
    photo.challenge ||
    photo.question ||
    photo.task ||
    photo.description ||
    ' ';

  const isVideo =
    photo.type === 'video' ||
    photo.type === 'Video' ||
    !!photo.thumbnail ||
    challengeText?.includes('Video') ||
    challengeText?.includes('Capture') ||
    challengeText?.includes('video') ||
    photoUrl?.includes('video');

  var photoDescription = photo.city
    ? `${photo.city}, ${photo.state}`
    : challengeText;
  if (descriptionOverride) {
    photoDescription = descriptionOverride;
  }

  return (
    <TouchableOpacity
      testID={`photoTile-${index}`}
      style={{
        alignItems: 'center',
        justifyContent: 'center',
        marginHorizontal: 10,
        marginVertical: 5,
        position: 'relative',
        backgroundColor: global?.color?.white1,
        width: width - 20,
        height: width - 20,
      }}
      activeOpacity={0.8}
      onPress={handlePress}>
      <CustomActivityIndicator
        size={'small'}
        style={{position: 'absolute'}}
        color={global?.color?.gray3}
      />

      {!isVideo && (
        <FastImage
          style={{width: width - 20, height: width - 20}}
          resizeMode={'cover'}
          source={{uri: cloudFlareOptimizeImage(photoUrl)}}
        />
      )}

      {!!isVideo && (
        <Video
          style={{width: width - 20, height: width - 20}}
          resizeMode={'cover'}
          source={{uri: photoUrl}}
        />
      )}

      <View
        style={{
          ...global?.style.fillAbsolute,
          justifyContent: 'flex-end',
          alignItems: 'flex-start',
        }}>
        <View
          style={{
            flexDirection: 'row',
            marginHorizontal: 15,
            alignItems: 'center',
            marginBottom: 5,
          }}>
          <FastImage
            source={markerIcon}
            resizeMode={FastImage?.resizeMode?.contain}
            style={{width: 18, height: 25}}
          />
          <BodyText
            text={photoDescription}
            bodyStyle={{alignItems: 'center', marginVertical: 0}}
            textStyle={{
              color: global?.color?.white,
              textAlign: 'left',
              marginBottom: 5,
              marginLeft: 5,
              ...descriptionStyle,
            }}
          />
        </View>
      </View>
      <TouchableOpacity
        onPress={async () => {
          // pulling the group in indirectly so we do not have to rely on computationally
          // expensive groups
          navigationRef.navigate('ConfirmModal', {
            titleText: `Are you 100% Sure You Want To Flag This Photo`,
            confirmText: 'Yes, Flag for Removal!',
            cancelText: 'Cancel',
            handleConfirm: () => {
              apiFlagPhotos({photoId: photo.id});
              navigationRef.goBack(null);
              navigationRef.goBack(null);
              fetchSetTopPhotos();
              Alert.alert(
                'This Photo Was Flagged For Removal',
                'We apologize for any inappropriate content. Thank you for helping to keep our community clean. The photo will be gone when you fully close and reopen the app.',
              );
            },
          });
        }}
        style={{
          ...{
            position: 'absolute',
            top: 0,
            right: 5,
            with: 20,
            height: 30,
            zIndex: 100,
            pointerEvents: 'auto',
          },
        }}>
        <Icon
          name={'flag'}
          size={30}
          color={global?.color?.white}
          // style={{ marginHorizontal: 7 }}
        />
      </TouchableOpacity>
    </TouchableOpacity>
  );
};

export default CommunityPhotos;
